/**
 * Astitva Living — Variant Selector Component
 * Handles swatches, options selection, URL state, price updates, gallery updates
 */

(function () {
  'use strict';

  class VariantSelector extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.updatePrice();
      } else {
        this.updateURL();
        this.updateVariantInput();
        this.updatePrice();
        this.updateGallery();
      }
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value || '';
      });
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment`);
      productForms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    updatePickupAvailability() {
      // Pickups can be handled natively by shopify if the element exists
      const pickup = document.querySelector('pickup-availability');
      if (pickup && this.currentVariant) {
        pickup.fetchAvailability(this.currentVariant.id);
      }
    }

    toggleAddButton(disable = true, text = '', modifyClass = true) {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}`);
      productForms.forEach((form) => {
        const addButton = form.querySelector('[type="submit"]');
        const addButtonText = form.querySelector('[type="submit"] > span') || addButton;
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = window.variantStrings.addToCart;
        }
      });
    }

    updatePrice() {
      const priceWrapper = document.getElementById(`price-${this.dataset.product}`);
      if (!priceWrapper) return;

      if (!this.currentVariant) {
        priceWrapper.classList.add('visibility-hidden');
        return;
      }

      priceWrapper.classList.remove('visibility-hidden');
      
      const price = this.currentVariant.price;
      const comparePrice = this.currentVariant.compare_at_price;
      const onSale = comparePrice && comparePrice > price;
      
      const priceEl = priceWrapper.querySelector('[data-price]');
      const comparePriceEl = priceWrapper.querySelector('[data-compare-price]');
      const savingsEl = priceWrapper.querySelector('.price__savings');

      if (priceEl) {
        priceEl.textContent = this.formatMoney(price);
      }

      if (comparePriceEl) {
        if (onSale) {
          comparePriceEl.textContent = this.formatMoney(comparePrice);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }

      if (savingsEl) {
        if (onSale) {
          const savings = comparePrice - price;
          savingsEl.textContent = `You save ${this.formatMoney(savings)}`;
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }
    }

    updateGallery() {
      if (!this.currentVariant || !this.currentVariant.featured_media) return;
      const gallery = document.querySelector('product-gallery');
      if (gallery) {
        gallery.setActiveMedia(this.currentVariant.featured_media.id);
      }
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    formatMoney(cents) {
      return (cents / 100).toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }

  customElements.define('variant-selector', VariantSelector);

})();
